<template>
  <div class="forms-overview">
    <nav class="level">
      <div class="level-left">
        <p class="level-item">
          <b-button
            @click="reload"
            type="is-info"
            icon-left="reload">
            Reload
          </b-button>
        </p>

        <p class="level-item">
          <b-button
            tag="router-link"
            to="/forms/create"
            type="is-success"
            icon-left="plus">
            New
          </b-button>
        </p>
      </div>
    </nav>

    <b-table
      narrowed
      hoverable
      striped
      paginated
      backend-pagination
      @page-change="pageChange"
      default-sort="created"
      default-sort-direction="desc"
      :per-page="limit"
      :total="total"
      :loading="loading"
      :data="data">

      <template slot-scope="props">
        <b-table-column field="id" label="No." sortable>
          {{ props.index + 1 + parseInt(lastRequest.skip ? lastRequest.skip : 0) }}
        </b-table-column>

        <b-table-column field="name" label="Name" sortable>
          {{ props.row.name }}
        </b-table-column>

        <b-table-column field="status" label="Status" sortable>
          <span :class="statusClass(props.row.status)">{{ statusName(props.row.status) }}</span>
        </b-table-column>

        <b-table-column field="updated" label="Updated" sortable>
          <span class="tag is-info">
            {{ props.row.updated }}
          </span>
        </b-table-column>

        <b-table-column field="created" label="Created" sortable>
          <span class="tag is-warning">
            {{ props.row.created }}
          </span>
        </b-table-column>

        <b-table-column field="actions" label="Actions">
          <b-dropdown hoverable aria-role="list">
            <b-button
              class="button is-primary"
              slot="trigger"
              tag="router-link"
              :to="'/forms/' + props.row.id + '/update'"
              type="is-info">

              <span>Update</span>
              <b-icon icon="menu-down"></b-icon>
            </b-button>

            <b-dropdown-item aria-role="listitem">
              <div
                @click.prevent="$router.push('/forms/' + props.row.id + '/analysis')">

                Analysis
              </div>
            </b-dropdown-item>
          </b-dropdown>
        </b-table-column>
      </template>

      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon
                icon="emoticon-sad"
                size="is-large">
              </b-icon>
            </p>
            <p>Nothing here.</p>
          </div>
        </section>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: 'FormsOverview',
  data: function() {
    return {
      loading: false,
      connection_error: false,

      forms: [],

      lastRequest: {},
      total: 0,
      limit: 20,
    }
  },
  created: function() {
    this.fetch({
      limit: this.limit,
    })
  },
  computed: {
    data: function() {
      if (this.forms.length) {
        const moment = this.$moment

        return this.forms.map(form => {
          return {
            id: form._id,

            name: form.name,
            status: form.status,
            updated: moment(form.updatedAt).format('D / MM / YY - h:m A'),
            created: moment(form.createdAt).format('D / MM / YY - h:m A'),
          }
        })
      }
      else {
        return []
      }
    },
  },
  methods: {
    reload: function() {
      this.fetch(this.lastRequest)
    },
    fetch: function(requestOptions={}) {
      const thisCompo = this

      this.loading = true
      this.connection_error = false
      this.lastRequest = requestOptions


      this.$api.formsList(requestOptions).then((response) => {
        thisCompo.forms = response.data.list

        thisCompo.limit = response.data.limit
        thisCompo.total = response.data.total

        thisCompo.loading = false
      }).catch( (err) => {
        if (err.response) {
          thisCompo.$buefy.toast.open({
            message: 'Bad request',
            type: 'is-danger',
            position: 'is-bottom'
          })
        }
        else {
          thisCompo.$buefy.toast.open({
            message: 'Connection error',
            type: 'is-danger',
            position: 'is-bottom'
          })
        }

        thisCompo.loading = false
        thisCompo.connection_error = true
      })
    },
    pageChange: function(pageNum) {
      this.fetch({
        limit: this.limit,
        skip: this.limit * ( pageNum - 1 ),
      })
    },

    statusName: function(value) {
      switch(value) {
        case true:
          return 'Enabled'

        case false:
          return 'Disabled'

        default:
          return 'Unknown'
      }
    },
    statusClass: function(value) {
      switch(value) {
        case true:
          return 'has-text-info'

        case false:
          return 'has-text-danger'

        default:
          return 'has-text-grey-light'
      }
    }
  },
}
</script>
